/* eslint-disable no-console */
import {Tooltip} from 'antd';
import {DivIcon, point} from 'leaflet';
import React from 'react';
import {MapContainer, TileLayer} from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import MarkerClusterGroup from 'react-leaflet-cluster';

import MarkerComp from './MarkerComp';
import SearchBar from './SearchBar';
import ZoomOutButton from './ZoomOutButton';

const MapComp: React.FC<{
  type: string;
  mapData: any[];
  markerRef: any;
  center?: any;
  setSelectedFacility: React.Dispatch<React.SetStateAction<string | undefined>>;
  facilityMean?: number;
}> = ({
  type,
  mapData,
  markerRef,
  center,
  setSelectedFacility,
  facilityMean
}) => {
  const customClusterIcon = (cluster: any) => {
    return new DivIcon({
      html: `<div className="clusterIcon">${cluster.getChildCount()}</div>`,
      iconSize: point(15, 15, true),
      className: 'customMarkerCluster'
    });
  };

  return (
    <MapContainer
      zoom={center ? 9 : 2}
      zoomControl={true}
      center={center ?? [0, 0]}
      markerZoomAnimation={true}
      attributionControl={false}
      scrollWheelZoom={false}
      dragging={true}
      maxBoundsViscosity={1.0}
      keyboard={false}
      className="map-container"
      style={{
        zIndex: 20,
        height: '100%',
        width: '100%',
        flex: 1
      }}
    >
      <TileLayer
        url="https://{s}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}{r}.png"
        noWrap={true}
      />

      <Tooltip title="Center Map">
        <ZoomOutButton setSelectedFacility={setSelectedFacility} />
      </Tooltip>

      <SearchBar
        mapData={mapData}
        markerRef={markerRef}
        setSelectedFacility={setSelectedFacility}
      />

      <MarkerClusterGroup
        chunkedLoading
        iconCreateFunction={customClusterIcon}
        // spiderfyDistanceMultiplier={1}
        showCoverageOnHover={false}
      >
        <MarkerComp
          type={type}
          mapData={mapData}
          markerRef={markerRef}
          facilityMean={facilityMean}
        />
      </MarkerClusterGroup>
    </MapContainer>
  );
};

export default MapComp;
